export type IEnv = "development" | "production" | "test" | "demo";

export function getEnv(): IEnv {
  return import.meta.env.VITE_APP_ENV as IEnv;
}
